<template>
  <div class="section-container position--relative">
    <section>
      <slot name="content"></slot>
    </section>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.section-container section {
  z-index: 1;
  position: relative;
  margin: 8px 0;
  padding: 16px 16px;
  border-radius: 3px;
  margin-bottom: 80px;
  background-color: #f07d7d;
}
</style>
